module.exports = __webpack_public_path__ + "static/media/MHRM09N1040.563ead3b.svg";